import SurveysService from "../../services/surveys-service";
import PieChart from "../charts/pie-chart";
import BarChart from "../charts/bar-chart";
import HorizontalBarChart from "../charts/horizontal-bar-chart";
import DoughnutChart from "../charts/doughnut-chart";
import LineChart from "../charts/line-chart";
import RadarChart from "../charts/radar-chart";
import moment from "moment";

import Vue from "vue";

Vue.component("surveys-overview", {
    components: {
        BarChart,
        HorizontalBarChart,
        PieChart,
        DoughnutChart,
        LineChart,
        RadarChart
    },
    data() {
        return {
            surveys: [],
            stats: {},
            diagrams: {},
            credits: {},
            fromDate: moment().startOf("year"),
            toDate: moment(),
            dateRange: __("Year To Date"),
            selectedSurveyId: null,
            topicsBreakdownDiagram: {
                options: {
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return (
                                    "Average Score: " + tooltipItem.yLabel + "%"
                                );
                                var label =
                                    data.datasets[tooltipItem.datasetIndex]
                                        .label || "";

                                if (label) {
                                    label += ": ";
                                }
                                label +=
                                    Math.round(tooltipItem.yLabel * 100) / 100 +
                                    "%";
                                return label;
                            }
                        }
                    },
                    height: "70",
                    plugins: {
                        datalabels: {
                            // hide datalabels for all datasets
                            display: true
                        }
                    },
                    legend: {
                        display: false
                    },
                    scale: {
                        ticks: {
                            beginAtZero: true,
                            max: 100,
                            min: 0,
                            stepSize: 20
                        }
                    }
                },
                data: null
            },
            diagramsDefinition: [
                {
                    group: "byDate",
                    type: "bar",
                    name: "total_surveys",
                    fields: ["totalSurveysFilled", "totalSurveysAnswered"],
                    labels: ["Total surveys filled", "Total surveys answered"],
                    colors: ["#00afef", "#8b72f5"],
                    title: "Filled surveys"
                },
                {
                    group: "byDate",
                    type: "line",
                    name: "surveys_overall",
                    fields: [
                        "totalSent",
                        "totalOpened",
                        "totalClicked",
                        "totalSurveysFilled",
                        "totalSurveysRedirected"
                    ],
                    labels: ["Sent", "Opened", "Clicked", "Filled", "Redirected"],
                    colors: ["#00afef", "#8b72f5", "#0153b9", "#44d4d2", "#ff6f61"],
                    title: "Surveys Overall",
                    tooltipSettings: {
                        titleIndex: 0
                    },
                    renderingOptions: [
                        {
                            index: 0,
                            fillRule: "+1",
                            gradientize: true,
                            backgroundColor: "rgba(0, 175, 239, 0.4)"
                        },
                        {
                            index: 1,
                            fillRule: "+1",
                            gradientize: true,
                            backgroundColor: "rgba(139, 114, 245, 0.4)"
                        },
                        {
                            index: 2,
                            fillRule: "+1",
                            gradientize: true,
                            backgroundColor: "rgba(1, 83, 185, 0.4)"
                        },
                        {
                            index: 3,
                            fillRule: true,
                            gradientize: true,
                            backgroundColor: "rgba(68, 212, 210, 0.4)"
                        },
                        {
                            index: 4,
                            fillRule: true,
                            gradientize: true,
                            backgroundColor: "rgba(255, 111, 97, 0.4)"
                        }
                    ]
                },
                {
                    group: "byDate",
                    type: "bar",
                    name: "responders_type",
                    fields: ["totalPositive", "totalNeutral", "totalNegative"],
                    labels: ["Promoters", "Neutral", "Detractors"],
                    colors: ["#91e084", "#ffe48f", "#ff8068"],
                    title: "Survey responders type",
                    tickStep: 1
                    // isPercentage: true,
                    // isStacked: true
                },
                {
                    group: "aggregation",
                    type: "bar",
                    name: "by_country",
                    key: "topNpsScoresPerNationality",
                    field: "nationalityCode",
                    title: "Scores by country"
                },
                {
                    group: "aggregation",
                    type: "bar",
                    name: "by_language",
                    key: "topNpsScoresPerLanguage",
                    field: "languageCode",
                    title: "Scores by language"
                },
                {
                    group: "aggregation",
                    type: "bar",
                    name: "by_traveller_type",
                    key: "topNpsScoresPerTravellerType",
                    field: "travellerType",
                    title: "Scores by traveller type"
                }
            ]
        };
    },
    mounted() {
        this.getStats();
        this.getCredits();
        this.getSurveys();
    },
    methods: {
        setDates(from, to, type) {
            this.fromDate = from;
            this.toDate = to;
            this.dateRange = type;
            this.getStats(this.selectedSurveyId);
        },
        async getSurveys() {
            const surveys = await SurveysService.index();
            this.surveys = surveys.data;
        },
        async getCredits() {
            this.credits = await SurveysService.credits.index();
        },
        async getStats(surveyId) {
            if (surveyId) {
                this.stats = await SurveysService.surveyStats(
                    surveyId,
                    moment(this.fromDate).format("YYYY-MM-DD"),
                    moment(this.toDate).format("YYYY-MM-DD")
                );
            } else {
                this.stats = await SurveysService.stats(
                    moment(this.fromDate).format("YYYY-MM-DD"),
                    moment(this.toDate).format("YYYY-MM-DD")
                );
            }

            // this.stats.totalFieldsFilled ? this.stats.npsScore = Math.round(this.stats.totalPositive / this.stats.totalFieldsFilled * 100) - Math.round(this.stats.totalNegative / this.stats.totalFieldsFilled * 100) : this.stats.npsScore = 0
            this.stats.totalSurveysFilled
                ? (this.stats.responseRate = Math.round(
                      (this.stats.totalSurveysAnswered /
                          this.stats.totalSurveysFilled) *
                          100
                  ))
                : (this.stats.responseRate = 0);

            this.topicsBreakdownDiagram.data = {
                labels: this.stats.topicsBreakdown.map(x => x.name),
                datasets: [
                    {
                        lineTension: 0,
                        data: this.stats.topicsBreakdown.map(
                            x => x.averageScore
                        ),
                        backgroundColor: "rgba(255, 0, 0, 0.3)"
                    }
                ]
            };

            this.diagramsDefinition
                .filter(x => x.group === "byDate")
                .forEach(diagram => {
                    this.diagrams[diagram.name] = {
                        chartdata: {
                            type: "category",
                            labels: this.stats.dateGrouped.data.map(
                                x => x.startDate
                            ),
                            datasets: diagram.fields.map((field, idx) => {
                                let rules = {
                                    label: diagram.labels[idx],
                                    fill: false,
                                    borderColor: diagram.colors[idx],
                                    data: this.stats.dateGrouped.data.map(x =>
                                        parseInt(x[field])
                                    ),
                                    hidden: false
                                };

                                if (diagram.type == "bar") {
                                    rules.backgroundColor = diagram.colors[idx];
                                }

                                if (diagram.type == "line") {
                                    rules.lineTension = 0;
                                }

                                return rules;
                            })
                        },
                        options: {
                            chartArea: { backgroundColor: "white" },
                            responsive: true,
                            legend: {
                                display: false
                            },
                            plugins: {
                                datalabels: {
                                    // hide datalabels for all datasets
                                    display: false
                                }
                            },
                            maintainAspectRatio: false
                        }
                    };
                    if (diagram.isStacked) {
                        this.diagrams[diagram.name].options.scales = {
                            xAxes: [
                                {
                                    stacked: true,
                                    maxBarThickness: 30,
                                    gridLines: {
                                        display: false
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    stacked: true,
                                    ticks: {
                                        beginAtZero: true
                                    },
                                    gridLines: {
                                        display: true,
                                        color: "rgb(173, 173, 173, 0.2)"
                                    }
                                }
                            ]
                        };
                    } else {
                        this.diagrams[diagram.name].options.scales = {
                            yAxes: [
                                {
                                    gridLines: {
                                        display: true,
                                        color: "rgb(173, 173, 173, 0.2)"
                                    },
                                    ticks: {
                                        beginAtZero: true
                                    }
                                }
                            ],
                            xAxes: [
                                {
                                    gridLines: {
                                        display: false
                                    },
                                    maxBarThickness: 30
                                }
                            ]
                        };
                    }

                    //Add Percentage To label
                    if (diagram.isPercentage) {
                        this.diagrams[
                            diagram.name
                        ].options.scales.yAxes[0].ticks.callback = function(
                            value,
                            index,
                            values
                        ) {
                            return value + "%";
                        };
                    }
                });

            // // Pass on additional rendering options for all diagrams
            this.diagramsDefinition.forEach(diagram => {
                if (diagram.renderingOptions) {
                    this.diagrams[diagram.name].renderingOptions =
                        diagram.renderingOptions;
                }

                if (diagram.tooltipSettings) {
                    this.diagrams[diagram.name].tooltipSettings =
                        diagram.tooltipSettings;
                }
            });
        }
    }
});
